(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Ventadetalle', Ventadetalle)
		.factory('VentadetalleFecha', VentadetalleFecha); 

    Ventadetalle.$inject = ['$resource', 'DateUtils'];
	VentadetalleFecha.$inject = ['$resource', 'DateUtils'];

	
    function Ventadetalle ($resource, DateUtils) {
        var resourceUrl =  'api/ventadetalles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentadetalleFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasdetallesfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
						//data.total = data.total / 1.21;
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
	}

	
})();
